import "./Group.scss";
import React, {useEffect, useState, useMemo} from "react";
import {Link} from "react-router-dom";
import SorterNav from "../SorterNav/SorterNav";
import ProductCard from "../ProductCard/ProductCard";
import Pagination from "../Pagination/Pagination";
import SorterDropdown from "../SorterDropDown/SorterDropDown";
import ToggleSorter from "../ToggleButton/ToggleSorter";
import CSwiper from "../CSwiper/CSwiper";
import {SwiperSlide} from "swiper/react";
import MultiRangeSlider from "../MultipleRangeSlider/MultiRangeSlider";
import GroupingSection from "../OrdibeheshtMainPage/GroupingSection";
import {prefixUrl} from "../../Utils/utilsData";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import Loader from "../Loader/Loader";

const Group = () => {
  const [cardData, setCardData] = useState([]); //all data content
  const [currentPage, setCurrentPage] = useState(1); //current page in pagination
  const PageSize = 12; //pagination capacity for each page
  const navigateTo = useNavigate();

  const [group, setGroup] = useState([]);
  const [showSubGroup, setShowSubGroup] = useState(true);
  const groupClasses = showSubGroup
    ? "grouping-category"
    : "hideGroup grouping-category";
  const [filters, setFilters] = useState({
    group: "",
    minPrice: 1,
    maxPrice: 10000000,
    text: "",
    sort: "",
    status: false,
    // inventory: "",
  });
  const [isLoad, setIsLoad] = useState(false)
  const filterHandler = (name, value) => {
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (name === "group") {
      // Construct the URL with the group value as a parameter
      const url = `/Group/SubGroups/${value.id}`;
      // Navigate to the constructed URL
      navigateTo(url);
      // setShowSubGroup(false);
    }
  };
  useEffect(() => {
    axios.post(`${prefixUrl()}/category/get.php`).then((response) => {
      setGroup(response.data.output);
      setIsLoad(true)
    });
  }, []);
  useEffect(() => {
    axios
      .post(`${prefixUrl()}/category/sendFilter.php`, filters)
      .then((response) => {
        setCardData(response.data.output);
      });
  }, [filters]);

  useEffect(() => {
    bigesstPrice();
  }, []);

  //get maximum price for send to ProgressBarSorter
  const bigesstPrice = () => {
    let maxPrice = Number.NEGATIVE_INFINITY;

    // console.log("Max Price:", maxPrice);
  };

  //setPriceValueSorter

  //data to show cardData with use pagination
  // const currentPageData = useMemo(() => {
  //   const firstPageIndex = (currentPage - 1) * PageSize;
  //   const lastPageIndex = firstPageIndex + PageSize;
  //   return cardData.slice(firstPageIndex, lastPageIndex);
  // }, [currentPage, PageSize, cardData]);

  //data of categories

  const latestProductHandler = () => {
    // const latestProduct = [...responseData.ProductData];
    const latestProduct = [...cardData];
    // Sort the data array based on the latest item
    const sortedData = latestProduct.reverse();
    setCardData(sortedData);
  };

  //data of sorterNavList
  const sorterNavList = [
    {title: "جدیدترین", id: "1"},
    {title: "محبوب ترین", id: "2"},
    {title: "پرفروش ترین", id: "3"},
    {title: "ارزان ترین", id: "4"},
    {title: "گران ترین", id: "5"},
  ];

  //cheked prouct you want is exist or not??

  // const removeFiltersHandler = () => {
  //   //a copy of all dataCards when is exists for the first time
  //   // const tempCardData = [...responseData.ProductData];
  //   setActiveItems([]);
  //   setPriceSorter(0);
  //   // setCardData(tempCardData);
  // };

  //for show sidebar in responsive
  const [sidebarVisible, setSidebarVisible] = useState(false);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  //this function used for for sortersList in responsive
  const [selectValue, setSelectValue] = useState("");
  let textFoot = group?.footerText && group?.footerText.replace(/\n/g, "<br>");

  return (
    <>
      {isLoad ?
        <div className="groupPageContainerPrnt__">
          <h1>دسته بندی ها</h1>
          <div className="categorySection_">
            <div className="categories__">
              <GroupingSection
                groups={group?.data}
                onSelect={filterHandler}
                className={groupClasses}
              />
            </div>
            <div className="caregoriesResponsive_">
              <CSwiper
                sildeNumber={2.5}
                bT320={3}
                bT480={3.5}
                bT640={4.5}
                bT768={4.5}
                bT994={4.5}
              >
                {/* {createSlides()} */}
                {group?.data?.map((v, index) => {
                  return (
                    <SwiperSlide key={index + "logOO"}>
                      {/* <Link
                    to={"/Group/SubGroup"}
                    className="categoryLink__"
                    key={"k" + index}
                  > */}
                      <div
                        className="category-card"
                        onClick={() => filterHandler("group", v)}
                      >
                        <div className="category-card-img">
                          <img src={v?.image} alt=""/>
                        </div>
                        <h6>{v?.title}</h6>
                      </div>
                      {/* </Link> */}
                    </SwiperSlide>
                  );
                })}
              </CSwiper>
            </div>
          </div>
          <div className="groupPageContainer__">
            <div className="allSortersResponsive__">
          <span className="filterResponsiveBtn__" onClick={toggleSidebar}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.75 5C22.75 5.41 22.41 5.75 22 5.75L11 5.75C10.59 5.75 10.25 5.41 10.25 5C10.25 4.59 10.59 4.25 11 4.25L22 4.25C22.41 4.25 22.75 4.59 22.75 5Z"
                fill="#778D50"
              />
              <path
                d="M7.75 5C7.75 5.41 7.41 5.75 7 5.75L2 5.75C1.59 5.75 1.25 5.41 1.25 5C1.25 4.59 1.59 4.25 2 4.25L7 4.25C7.41 4.25 7.75 4.59 7.75 5Z"
                fill="#778D50"
              />
              <path
                d="M22.75 12C22.75 12.41 22.41 12.75 22 12.75L17 12.75C16.59 12.75 16.25 12.41 16.25 12C16.25 11.59 16.59 11.25 17 11.25L22 11.25C22.41 11.25 22.75 11.59 22.75 12Z"
                fill="#778D50"
              />
              <path
                d="M13.75 12C13.75 12.41 13.41 12.75 13 12.75L2 12.75C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25L13 11.25C13.41 11.25 13.75 11.59 13.75 12Z"
                fill="#778D50"
              />
              <path
                d="M22.75 19C22.75 19.41 22.41 19.75 22 19.75L11 19.75C10.59 19.75 10.25 19.41 10.25 19C10.25 18.59 10.59 18.25 11 18.25L22 18.25C22.41 18.25 22.75 18.59 22.75 19Z"
                fill="#778D50"
              />
              <path
                d="M7.75 19C7.75 19.41 7.41 19.75 7 19.75L2 19.75C1.59 19.75 1.25 19.41 1.25 19C1.25 18.59 1.59 18.25 2 18.25L7 18.25C7.41 18.25 7.75 18.59 7.75 19Z"
                fill="#778D50"
              />
              <path
                d="M11.75 17L11.75 21C11.75 21.41 11.41 21.75 11 21.75C10.59 21.75 10.25 21.41 10.25 21L10.25 17C10.25 16.59 10.59 16.25 11 16.25C11.41 16.25 11.75 16.59 11.75 17Z"
                fill="#778D50"
              />
              <path
                d="M11.75 3L11.75 7C11.75 7.41 11.41 7.75 11 7.75C10.59 7.75 10.25 7.41 10.25 7L10.25 3C10.25 2.59 10.59 2.25 11 2.25C11.41 2.25 11.75 2.59 11.75 3Z"
                fill="#778D50"
              />
              <path
                d="M13.75 10L13.75 14C13.75 14.41 13.41 14.75 13 14.75C12.59 14.75 12.25 14.41 12.25 14L12.25 10C12.25 9.59 12.59 9.25 13 9.25C13.41 9.25 13.75 9.59 13.75 10Z"
                fill="#778D50"
              />
            </svg>
            فیلتر
          </span>
              <div className="responsive_sortNav">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
                    fill="#778D50"
                  />
                  <path
                    d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
                    fill="#778D50"
                  />
                  <path
                    d="M14 17.75H10C9.59 17.75 9.25 17.41 9.25 17C9.25 16.59 9.59 16.25 10 16.25H14C14.41 16.25 14.75 16.59 14.75 17C14.75 17.41 14.41 17.75 14 17.75Z"
                    fill="#778D50"
                  />
                </svg>

                <select
                  defaultValue={selectValue}
                  onChange={(e) => filterHandler("sort", e.target.value)}
                >
                  {sorterNavList.map((v, index) => {
                    return (
                      <option key={index} value={v.id}>
                        {v.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div
              className={`sidebarResponsive_ ${sidebarVisible ? "visible" : ""}`}
            >
              <div className="closeBtn__">
            <span onClick={toggleSidebar}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.64097 12.9834C7.48264 12.9834 7.32432 12.925 7.19932 12.8C6.95765 12.5584 6.95765 12.1584 7.19932 11.9167L11.916 7.20005C12.1577 6.95838 12.5577 6.95838 12.7993 7.20005C13.041 7.44172 13.041 7.84172 12.7993 8.08338L8.08264 12.8C7.96597 12.925 7.79931 12.9834 7.64097 12.9834Z"
                  fill="#B9B9B9"
                />
                <path
                  d="M12.3577 12.9834C12.1993 12.9834 12.041 12.925 11.916 12.8L7.19932 8.08338C6.95765 7.84172 6.95765 7.44172 7.19932 7.20005C7.44097 6.95838 7.84097 6.95838 8.08264 7.20005L12.7993 11.9167C13.041 12.1584 13.041 12.5584 12.7993 12.8C12.6743 12.925 12.516 12.9834 12.3577 12.9834Z"
                  fill="#B9B9B9"
                />
                <path
                  d="M12.4998 18.9583H7.49984C2.97484 18.9583 1.0415 17.025 1.0415 12.5V7.49996C1.0415 2.97496 2.97484 1.04163 7.49984 1.04163H12.4998C17.0248 1.04163 18.9582 2.97496 18.9582 7.49996V12.5C18.9582 17.025 17.0248 18.9583 12.4998 18.9583ZM7.49984 2.29163C3.65817 2.29163 2.2915 3.65829 2.2915 7.49996V12.5C2.2915 16.3416 3.65817 17.7083 7.49984 17.7083H12.4998C16.3415 17.7083 17.7082 16.3416 17.7082 12.5V7.49996C17.7082 3.65829 16.3415 2.29163 12.4998 2.29163H7.49984Z"
                  fill="#B9B9B9"
                />
              </svg>
            </span>
              </div>
              <div className="listOfFiltersSidebarResponsive__">
                <SorterDropdown
                  title={"جستجو"}
                  sorterMode={"search"}
                  // cardData={[...responseData.ProductData]}
                  setCardData={setCardData}
                  onSearch={filterHandler}
                />
                <ToggleSorter
                  title={"محصولات موجود"}
                  onClickHandler={filterHandler}
                />

                <MultiRangeSlider
                  min={1}
                  max={10000000}
                  onSelectPrice={filterHandler}
                />
                <div className="filterButtonsContainer_">
                  {/* <button className="filteredButton" onClick={filterBtnHandler}>
                فیلتر
              </button> */}
                  <button className="removeFilters">حذف فیلترها</button>
                </div>
              </div>
            </div>
            <div className="allContentGroupPrnt_">
              <div className="listOfFiltersBox__">
                <SorterDropdown
                  title={"جستجو"}
                  sorterMode={"search"}
                  // cardData={[...responseData.ProductData]}
                  setCardData={setCardData}
                  onSearch={filterHandler}
                />
                <ToggleSorter
                  title={"محصولات موجود"}
                  onClickHandler={filterHandler}
                />

                <MultiRangeSlider
                  min={1}
                  max={10000000}
                  onSelectPrice={filterHandler}
                />
                <div className="filterButtonsContainer_"></div>
              </div>
              <div className="groupContentPrnt_">
                <SorterNav items={sorterNavList} onSelect={filterHandler}/>
                <div className="groupConetnt_">
                  {cardData?.map((v, index) => {
                    return (
                      
                      <ProductCard
                        url={v?.url}
                        key={"lo" + index}
                        title={v?.title}
                        src={v?.images[0]?.url}
                        id={v?.id}
                        mainPrice={v?.mainPrice}
                        inventory={v?.inventory}
                        offer={v?.offer}
                        offerPrice={v?.offerPrice}
                        offPercent={v?.offPercent}
                        score={v?.score}
                        cardModel={v?.cardModel}
                        className={"cardWidth__"}
                        productInfo={v}
                        status={v?.status}
                        defaultValue={v?.defultValue}
                      />
                    );
                  })}
                </div>

                {/* <Pagination
              key={59955}
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={cardData.length}
              pageSize={PageSize}
              onPageChange={(page) => setCurrentPage(page)}
            /> */}
              </div>
            </div>
            <div
              className="article__"
              dangerouslySetInnerHTML={{__html: textFoot}}
            />
          </div>
        </div>
        : <Loader/>}
    </>
  );
};

export default Group;
